/**
 * 个人中心页面
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { logout, getCurrentUser } from '../services/auth';
import TabBar from '../components/TabBar';
import './Profile.css';

const Profile = () => {
  const navigate = useNavigate();
  const currentUser = getCurrentUser();

  const menuItems = [
    { icon: '📱', title: '设备绑定', subtitle: '绑定新的 WiFi 设备', onClick: () => navigate('/bind-device') },
    ...(currentUser?.username === 'admin' ? [
      { icon: '👥', title: '用户管理', subtitle: '管理用户和设备绑定', onClick: () => navigate('/admin/users') },
    ] : []),
    { icon: '🔔', title: '消息通知', subtitle: '管理通知设置', onClick: () => alert('功能开发中...') },
    { icon: '⚙️', title: '设置', subtitle: '应用设置和偏好', onClick: () => alert('功能开发中...') },
    { icon: '❓', title: '帮助与反馈', subtitle: '获取帮助或提供反馈', onClick: () => alert('功能开发中...') },
    { icon: 'ℹ️', title: '关于', subtitle: '版本 v1.2.0', onClick: () => alert('WiFi Monitor v1.2.0\n© 2025') },
  ];

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="page-container profile-page">
      <header className="profile-header">
        <div className="user-avatar">
          <span className="avatar-icon">👤</span>
        </div>
        <h2 className="user-name">{currentUser?.name || '用户'}</h2>
        <p className="user-username">@{currentUser?.username || 'user'}</p>
      </header>

      <div className="stats-cards">
        {[
          { icon: '🎮', value: '8', label: '管理设备' },
          { icon: '⏱️', value: '42h', label: '今日时长' },
          { icon: '📊', value: '2.5GB', label: '今日流量' },
        ].map((stat, i) => (
          <div key={i} className="stat-card">
            <div className="stat-card-icon">{stat.icon}</div>
            <div className="stat-card-value">{stat.value}</div>
            <div className="stat-card-label">{stat.label}</div>
          </div>
        ))}
      </div>

      <div className="menu-section">
        <div className="section-title">功能</div>
        {menuItems.map((item, index) => (
          <div key={index} className="menu-item" onClick={item.onClick}>
            <div className="menu-item-icon">{item.icon}</div>
            <div className="menu-item-content">
              <div className="menu-item-title">{item.title}</div>
              <div className="menu-item-subtitle">{item.subtitle}</div>
            </div>
            <div className="menu-item-arrow">›</div>
          </div>
        ))}
      </div>

      <div className="logout-section">
        <button className="logout-button" onClick={handleLogout}>
          <span>🚪</span>
          <span>退出登录</span>
        </button>
      </div>

      <div className="version-info">
        <p>WiFi Monitor v1.2.0</p>
        <p className="copyright">© 2025 All Rights Reserved</p>
      </div>

      <TabBar />
    </div>
  );
};

export default Profile;
